/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {Languages} from './Languages'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {useIntl} from 'react-intl'

const HeaderUserMenu: FC = () => {
  const {logout, auth} = useAuth()
  const intl = useIntl()

  const avatarUrl = localStorage.getItem('avatar')
  const lastname = localStorage.getItem('lastname')
  const firstname = localStorage.getItem('firstname')
  const email = localStorage.getItem('email')
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary  py-4 fs-6 w-350px'
      data-kt-menu='true'
      data-kt-menu-placement='bottom-start'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-3'>
            <img alt='Logo' src={toAbsoluteUrl(process.env.REACT_APP_API_URL + '/' + avatarUrl)} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder text-bluee d-flex align-items-center fs-5'>
              {firstname} {lastname}
              {/* <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>Pro</span> */}
            </div>
            <a href='#' className='text-muted text-hover-primary fs-7'>
              {email}
            </a>
          </div>
        </div>
      </div>
      <div className='separator my-2' />
      <div className='menu-item px-5'>
        <Link to={'/crafted/pages/profile'} className='menu-link px-3 '>
          <img src='/settings.png' style={{maxWidth:"1.3rem"}}/>
          <div className='mx-3 text-darkblue fs-7'>{intl.formatMessage({id: 'GORELLA.COMMON.SETTINGS'})}</div>
        </Link>
      </div>

      {/* <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          <span className='menu-text'>My Projects</span>
          <span className='menu-badge'>
            <span className='badge badge-light-danger badge-circle fw-bolder fs-7'>3</span>
          </span>
        </a>
      </div> */}

      {/* <div
        className='menu-item px-5'
        data-kt-menu-trigger='hover'
        data-kt-menu-placement='left-start'
        data-kt-menu-flip='bottom'
      > */}
      {/* <a href='#' className='menu-link px-5'>
          <span className='menu-title'>My Subscription</span>
          <span className='menu-arrow'></span>
        </a> */}

      {/* <div className='menu-sub menu-sub-dropdown w-175px py-4'>
          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Referrals
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Billing
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Payments
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link d-flex flex-stack px-5'>
              Statements
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='View your statements'
              ></i>
            </a>
          </div>

          <div className='separator my-2'></div>

          <div className='menu-item px-3'>
            <div className='menu-content px-3'>
              <label className='form-check form-switch form-check-custom form-check-solid'>
                <input
                  className='form-check-input w-30px h-20px'
                  type='checkbox'
                  value='1'
                  defaultChecked={true}
                  name='notifications'
                />
                <span className='form-check-label text-muted fs-7'>Notifications</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          My Statements
        </a>
      </div> */}

      {/* <div className='separator my-2'></div> */}

      <Languages />

      {/* <div className='menu-item px-5 my-1'>
        <Link to='/crafted/account/settings' className='menu-link px-5'>
          Account Settings
        </Link>
      </div> */}

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          {/* <KTSVG path='/logout.svg' className='' /> */}
          <img src='/logout.png' style={{maxWidth:"1rem"}}/>
          <div className='mx-3 text-darkblue fs-7'>{intl.formatMessage({id: 'GORELLA.COMMON.LOGOUT'})}</div>
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
